"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var BaseStyledDialog_1 = __importDefault(require("./BaseStyledDialog"));
var DeleteConfirmationDialog = function (props) {
    var title = props.title || 'This entity will be permanently deleted';
    var contentText = props.contentText || 'You will not be able to undo this action.';
    var actionButtonText = props.actionButtonText || 'Delete';
    return (react_1.default.createElement(BaseStyledDialog_1.default, { open: props.open, onClose: props.handleClose },
        react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title", variant: "h3" }, title),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.DialogContentText, { id: "alert-dialog-description" }, contentText)),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { color: "secondary", variant: "text", onClick: props.handleClose }, "Cancel"),
            react_1.default.createElement(material_1.Button, { variant: "contained", color: "error", onClick: props.handleSave }, actionButtonText))));
};
exports.default = DeleteConfirmationDialog;
